import { render, staticRenderFns } from "./forgotPhone.vue?vue&type=template&id=1bb8d8f8&scoped=true"
import script from "./forgotPhone.vue?vue&type=script&lang=js"
export * from "./forgotPhone.vue?vue&type=script&lang=js"
import style0 from "./forgotPhone.vue?vue&type=style&index=0&id=1bb8d8f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8d8f8",
  null
  
)

export default component.exports